<template>
    <div>
        <div class="table-controls | u-text-right">
            <div class="page-block__header">
                <h1 class="tabulator__title">{{ trans('page.customers.title') }}</h1>
                <div>
                    <customer-router-link
                        :to="{ name: 'customersCreate' }"
                        class="btn btn--ghost btn--small | u-margin-right-narrow"
                        dusk="create-customer-button"
                    >
                        {{ trans('action.add') }}
                    </customer-router-link>
                    <button class="btn btn--ghost btn--small" @click="downloadCsv">
                        {{ trans('action.download.csv') }}
                    </button>
                </div>
            </div>
        </div>
        <div ref="table"></div>
    </div>
</template>

<script>
import Tabulator from 'tabulator-tables';
import customerMixin from '../mixins/customer.js';

import '../styles/_tabulator.scss';

export default {
    mixins: [customerMixin],
    props: {
        tableData: {
            type: Array,
            required: true
        }
    },
    /**
     * Add all the properties found in the data object to Vue’s reactivity system.
     *
     * @return {object}
     */
    data() {
        return {
            tabulator: null,
            columns: [
                {
                    title: trans('customer.organization'),
                    field: 'organization',
                    headerFilter: 'input',
                    headerFilterParams: { values: true },
                    headerFilterPlaceholder: trans('action.filter')
                },
                {
                    title: trans('customer.first_name'),
                    field: 'first_name',
                    headerFilter: 'input',
                    headerFilterPlaceholder: trans('action.search')
                },
                {
                    title: trans('customer.last_name'),
                    field: 'last_name',
                    headerFilter: 'input',
                    headerFilterPlaceholder: trans('action.search')
                },
                {
                    title: trans('customer.email'),
                    field: 'email',
                    headerFilter: 'input',
                    headerFilterPlaceholder: trans('action.search')
                },

                {
                    title: trans('customer.has_user'),
                    field: 'has_user',
                    formatter: 'tickCross',
                    formatterParams: {
                        allowEmpty: true,
                        allowTruthy: true,
                        crossElement:
                            '<button class="btn btn--access btn--small">' +
                            trans('page.customers.give-access') +
                            '</button>'
                    },
                    headerFilter: 'select',
                    headerFilterParams: { values: true },
                    headerFilterPlaceholder: trans('action.filter'),
                    cellClick: this.giveAccessCellClick
                }
            ]
        };
    },
    watch: {
        tableData: {
            /**
             * Watcher for the tableData
             *
             * @param {array} newData
             */
            handler(newData) {
                this.tabulator.replaceData(newData);
                this.tabulator.redraw(true);
            },
            deep: true
        }
    },
    /**
     * Called after the instance has been mounted.
     */
    mounted() {
        if (!this.canGiveWhitelabelAccess) {
            this.columns = this.columns.filter(column => column.field != 'has_user');
        }

        this.tabulator = new Tabulator(this.$refs.table, {
            columns: this.columns,
            data: this.tableData,
            layout: 'fitColumns',
            responsiveLayout: 'collapse',
            resizableColumns: false,
            selectable: false
        });
    },
    methods: {
        /**
         * Action when the icon is clicked.
         *
         * @param {object} event
         * @param {CellComponent} cell
         */
        giveAccessCellClick(event, cell) {
            if (!cell.getRow().getData().has_user) {
                this.$emit('giveAccess', cell.getRow().getData());
            }
        },
        /**
         * Download the contents of the table in CSV format.
         */
        downloadCsv() {
            this.tabulator.download('csv', 'data.csv');
        }
    }
};
</script>
